import React from 'react'
import { Mdx, Image } from '@ta-interaktiv/contentbricks'

import './styles.scss'

interface Props {
  title?: string
  text?: string
  image?: string
  time?: string
  cssClass?: string
}

export const LifeStep = ({
  title,
  text = '',
  time = '',
  image,
  cssClass = ''
}: Props) => {
  console.log(image, text)
  return (
    <div className={'ui container ' + cssClass} id='lifestep'>
      <div className='ui stackable grid'>
        <div className='ui eight wide column imageHolder'>
          {image && image.indexOf('json') === -1 && (
            <>
              <div className='time'>
                <div className='timeText'>{time}</div>
              </div>
              <Image file={require('images/' + image)} />
            </>
          )}
          {image && image.indexOf('json') !== -1 && (
            <>
              <div className='time'>{time}</div>
            </>
          )}
        </div>
        <div className='ui eight wide column'>
          <div className='lifetext vertCenter'>
            {title && <h4 className='title'>{title}</h4>}
            <Mdx file={require('text/' + text)} />
          </div>
        </div>
      </div>
    </div>
  )
}
